import { Observable } from './observable';
import { lift } from './observer';
import { Subscription } from './subscription';
export class Subject {
  constructor() {
    this.observers = new Set();
  }
  subscribe(observer) {
    const observerObject = lift(observer);
    this.observers.add(observerObject);
    const subscription = new Subscription();
    subscription.add(() => {
      this.observers.delete(observerObject);
    });
    return subscription;
  }
  next(value) {
    this.observers.forEach(observer => {
      var _observer$next;
      return (_observer$next = observer.next) === null || _observer$next === void 0 ? void 0 : _observer$next.call(observer, value);
    });
  }
  complete() {
    this.observers.forEach(observer => {
      var _observer$complete;
      return (_observer$complete = observer.complete) === null || _observer$complete === void 0 ? void 0 : _observer$complete.call(observer);
    });
    this.observers.clear();
  }
  error(err) {
    this.observers.forEach(observer => {
      var _observer$error;
      return (_observer$error = observer.error) === null || _observer$error === void 0 ? void 0 : _observer$error.call(observer, err);
    });
    this.observers.clear();
  }
  asObservable() {
    return new Observable(observer => this.subscribe(observer));
  }
  dispose() {
    this.observers.clear();
  }
}